{
  "client": "Client",
  "marketValue": "Total Assets",
  "completedAt": "Completed At",
  "organization": "Organization",
  "previousInformationUpdate": "Previous information update",
  "daysPastDue": "Days Past Due",
  "search": "Search",
  "days": "days",
  "table": {
    "organization": "Organization"
  }
}
